<form [formGroup]="formGroup">
	<div class="obg-m-id-select-content">
		<div class="input-group">
			<obg-m-cpr-number-field
				[inlineTips]="true"
				[formGroup]="formGroup"
				[fieldValue]="formGroup.controls.shouldRememberUser && lastUsedCpr"
				(fieldChange)="uiInteractionFieldEvent($event)"
				[translationPrefix]="'login.cprnumber'"
				(focused)="onFocused($event)"
			>
			</obg-m-cpr-number-field>
		</div>
	</div>
	<div class="obg-m-id-select-actions">
		<div class="extra-actions">
			<mat-slide-toggle
				*ngIf="formGroup.controls.shouldRememberUser"
				formControlName="shouldRememberUser"
				test-id="login-should-remember-user"
				color="primary"
				(change)="uiInteractionFieldEvent('shouldRememberUser')"
			>
				{{ "login.rememberEmail.placeholder" | translate }}
			</mat-slide-toggle>
			<div *ngIf="errorCode" class="validation-error">
				{{ errorPrefix + errorCode | translate }}
			</div>
			<div class="obg-m-dga-login-buttons">
				<obg-mitid-login-button-component
					(click)="onSubmit()"
					[busy]="isBusy"
					[label]="buttonLabel | translate"
					[showMitIdIcon]="true"
					[disabled]="formGroup?.invalid && formGroup?.get('cprNumber').value"
					data-test-id="mitid-login-button-component"
				></obg-mitid-login-button-component>
			</div>
		</div>
	</div>
</form>
